<template>
    <div :class="['class_box', theme]">
        <div class="class_row">
            <div class="selector">
                <SelectComponent class="account_selector" theme="classification_theme" v-model="dataAccount"
                    :key="dataAccountKey" :weirdOptions="options" :isAccount="isAccount" />
                <div v-if="localMoney > 0" class="mt-1">{{ toMoney(localMoney) }}</div>
            </div>
            <div
                :class="['percentage', { 'is-disabled-local': isDisabledPercentage, 'is-unselectable': isDisabledPercentage, }]">
                <div class="percentage_input_wrapper">
                    <input class="percentage_input" v-model="percentageData" type="string" size="3" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectComponent from "@/components/classification/SelectComponent";
import { parseToMoney } from "@/utils/currency";

export default {
    name: "ClassificationBox",
    components: {
        SelectComponent,
    },
    props: {
        options: {
            type: Array,
            required: true,
            default: () => null,
        },
        account: {
            type: Number,
            default: -1,
        },
        theme: {
            type: String,
            default: '',
        },
        money: {
            type: Number,
            default: 0,
        },
        percentage: {
            type: Number,
            default: 0,
        },
        isAccount: {
            type: Boolean,
            default: false,
        },
        isDisabledPercentage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            percentageData: 0,
            dataAccount: -1,
            dataAccountKey: Date.now(),
            localMoney: 0,
        };
    },
    methods: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
    mounted() {
        this.dataAccount = this.account;
        this.dataAccountKey = Date.now();
        this.percentageData = this.percentage;
        this.localMoney = this.money
        if (this.account == '') {
            this.account = 'Sin Clasificar';
        }
    },
    beforeDestroy() {
    },
    watch: {
        dataAccount(newValue) {
            this.dataAccount = newValue;
            this.$emit("update-selection", newValue);
        },
        account(new_value) {
            this.dataAccount = new_value
        },
        percentageData(newValue) {
            const numericValue = newValue.toString().replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
            var nextVal = numericValue ? parseInt(numericValue, 10) : 0;
            if (nextVal > 100) {
                nextVal = parseInt(numericValue / 10, 10);
            } else if (nextVal < 0) {
                nextVal = 0;
            }
            this.$emit("update-selection-percentage", nextVal);
            this.percentageData = nextVal;
        },
        percentage(newPercentage) {
            this.percentageData = newPercentage
        },
        money(newMoney) {
            this.localMoney = newMoney
        }
    },
};
</script>
<style lang="scss" scoped>
.third_title {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #344054;
    text-align: left;
}

.third_box_1 {
    flex: 3;
    background-color: #fff;
    border: 1px solid #EAECF0;
}

.third_box_2 {
    flex: 3;
    background-color: #ECFDF3;
    border: 1px solid #ABEFC6;
}

.third_box_3 {
    flex: 3;
    background-color: #EFF8FF;
    border: 1px solid #B2DDFF;
}

.class_box {
    margin-bottom: 8px;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    vertical-align: middle;
    justify-content: center;
}

.class_row {
    display: flex;
    flex-direction: row;
}

.selector {
    flex: 3;
    margin-right: 4px;
}

.percentage {
    flex: 1;
    position: relative;
    display: inline-block;
}

.percentage_input {
    font-size: 16px;
    line-height: 16px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    height: 42px;
    position: relative;

}

.percentage_symbol {
    position: absolute;
    right: 12px;
    top: 19px;
    transform: translateY(-50%);
    font-size: 16px;
    z-index: 2;
    pointer-events: none;
}

.percentage_input_wrapper {
    width: fit-content;
    min-width: fit-content;
    max-width: fit-content;
}

.percentage_input_wrapper::after {
    content: '%';
    position: absolute;
    left: 44px;
    top: 19px;
    transform: translateY(-50%);
    font-size: 16px;
    color: #6b7280;
    pointer-events: none;
    z-index: 2;
}
</style>